import { HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { GoogleService } from './google.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleSlidesService extends GoogleService {
  public static readonly ENDPOINT_SUBSCRIBE = 'slides/subscribe';
  public static readonly ENDPOINT_ITEM = 'slides/item';

  subscribe(account: string, id: string, cid: string) {
    const options = this.componentUtilsService.getRequestOptions();
    const body = { account, id, cid };

    const request = new HttpRequest(
      'POST',
      environment.GOOGLE_SERVICE_URL + GoogleSlidesService.ENDPOINT_SUBSCRIBE,
      body,
      options,
    );

    return this.httpClient
      .request(request)
      .toPromise()
      .then((response: any) => {
        if (response && response.body) {
          return 'success';
        } else {
          throw new Error('Unexpected response');
        }
      })
      .catch((err) => {
        console.error('Error calling "/slides/subscribe" endpoint.', err);

        throw err;
      });
  }

  getFileInfo(account: string, id: string) {
    const options = this.componentUtilsService.getRequestOptions();
    options.params = new HttpParams({
      fromObject: { account, id },
    });

    const request = new HttpRequest(
      'GET',
      environment.GOOGLE_SERVICE_URL + GoogleSlidesService.ENDPOINT_ITEM,
      options,
    );

    return this.httpClient
      .request(request)
      .toPromise()
      .then((response: any) => {
        if (response && response.body) {
          return response.body;
        } else {
          throw new Error('Unexpected response');
        }
      })
      .catch((err) => {
        console.error('Error calling "/item" endpoint.', err);

        throw err;
      });
  }
}
